<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fm-title">Acknowledgements</h2>
<p class="noindent">My thanks go to Rupert Harding at Pen and Sword, for his patience and always welcome feedback and encouragement. Also, to my erstwhile classmate at primary school, Katharine Ball, now Librarian of the Leddy Library, University of Windsor, Ontario, Canada, for hunting down a difficult-to-find history of the War of 1812. To my wife, Mairi Ann, whose encouragement enabled me to keep writing. Finally, to my late parents, who, many years ago, bought me a little desk at which I copied out favourite passages from Ladybird Books, a process that taught me that writing was not just something one did at school.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?2268c918